import { handleKeyDown } from "_services";
import { CommonInput, CommonModal, CustomSelect } from "components";
import { UserContext } from "context";
import { addTotalFrieght, editLRTotalFrieght, editTotalFrieght } from "features";
import { errorSchema, utils } from "helper";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import StorageService from "utils/StorageServices/StorageServices";

const EditConsignorFreight = (props) => {
  const { data } = props;
  const { lr_freight } = data;

  const intialTotal = {
    lr_id: "",
    freight_type: lr_freight?.freight_type,
    qty: lr_freight?.qty,
    rate: lr_freight?.rate,
    amount: lr_freight?.total_freight,
    tds_deduction: 0,
  };

  const dispatch = useDispatch();
  const { masterData } = useContext(UserContext);
  const [formTotal, setFormTotal] = useState(intialTotal);
  const [formError, setFormError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [freightTypeList, setFreightTypeList] = useState([]);
  const [tdsChecked, setTdsChecked] = useState(false);
  const [tdsAmmount, setTdsAmmount] = useState(0);
  const [tdsList, setTDsList] = useState([]);
  const [formTotalName, setFormTotalName] = useState(intialTotal);

  useEffect(() => {
    if (masterData) {
      const Tds = masterData.tds_section_list?.map((item) => {
        return { label: item?.name, value: item?.id };
      });

      const lrFreight = masterData?.contract_rate_type_list?.map((item) => {
        return { label: item?.name, value: item?.id };
      });

      setTDsList(Tds);
      setFreightTypeList(lrFreight);
      setFormTotal((prev) => ({ ...prev, trip_id: props?.tripId }));
    }
  }, [masterData, props?.tripId]);

  useEffect(() => {
    if (lr_freight) {
      setFormTotal({
        ...formTotal,
        amount: lr_freight?.total_freight ? lr_freight?.total_freight : 0,
        rate: lr_freight?.rate ? lr_freight?.rate : 0,
        qty: lr_freight?.qty ? lr_freight?.qty : 0,
        freight_type: lr_freight?.freight_type ? lr_freight?.freight_type : 4,
        tds_deduction: lr_freight?.tds_deduction ? lr_freight?.tds_deduction : 0,
      });

      if (lr_freight?.tds_deduction && lr_freight?.tds_deduction > 0) {
        setTdsChecked(true);
      }
    }
  }, [lr_freight]);

  useEffect(() => {
    // if (!lr_freight?.tds_deduction || lr_freight?.tds_deduction < 0) {
    //   setFormTotal((prev) => ({
    //     ...prev,
    //     tds_diduction: tdsChecked ? 1 : 0,
    //   }));

    //   setFormTotalName((prev) => ({
    //     ...prev,
    //     tds_diduction: tdsChecked
    //       ? { label: "1%", value: "1" }
    //       : { label: "", value: "" },
    //   }));
    // }

    setFormTotal((prev) => ({
      ...prev,
      tds_deduction: tdsChecked ? (lr_freight?.tds_deduction || 1) : 0, // Fix typo bhi
    }));

    setFormTotalName((prev) => ({
      ...prev,
      tds_deduction: tdsChecked
        ? tdsList?.find((i) => i?.value === (lr_freight?.tds_deduction || 1)) || { label: "1%", value: "1" }
        : { label: "", value: "" },
    }));
  }, [tdsChecked, lr_freight?.tds_deduction]);

  useEffect(() => {
    if (formTotal?.freight_type !== 6) {
      setFormTotal((prev) => ({
        ...prev,
        amount: Number(prev?.qty) * Number(prev.rate),

      }));
    }
  }, [formTotal.rate, formTotal?.qty, formTotal?.freight_type]);

  useEffect(() => {
    setTdsAmmount((formTotal?.amount * formTotal?.tds_deduction) / 100 || 0); // ✅
  }, [formTotal?.amount, formTotal?.tds_deduction]);

  const handleOnChange = async (name, value) => {
    const stateObj = {
      ...formTotal,
      [name]: value,
    };
    setFormTotal(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        { ...stateObj },
        errorSchema.addTotalFreigthSchema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const onSubmitTotal = async () => {
    const validationResult = await utils.checkFormError(
      { ...formTotal },
      errorSchema.addTotalFreigthSchema
    );
    const payload = {
      company_id: StorageService?.getCompanyId(),
      lr_id: data?._id,
      freight_type: formTotal?.freight_type,
      qty: Number(formTotal?.qty),
      rate: Number(formTotal?.rate),
      amount: Number(formTotal?.amount),
      tds_diduction: formTotal?.tds_deduction ? formTotal?.tds_deduction : 0,
    };

    try {
      if (validationResult === true) {
        setIsLoading(true);
        const res = await dispatch(editLRTotalFrieght(payload));
        if (res?.payload?.responseCode === 200) {
          setIsLoading(false);
          handleCloseTotal();
          props.callbackTotal();
        } else {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
        setFormError(validationResult);
      }
    } catch {
      setIsLoading(false);
    }
  };

  const allClear = () => {
    setFormTotal({ ...intialTotal });
  };

  const handleCloseTotal = () => {
    props?.closeModal();
    allClear();
  };

  const modifyProps = {
    ...props,
    onSubmit: onSubmitTotal,
    isLoading: isLoading,
    disabled: isLoading,
    submitTitle: isLoading ? "Updating.." : "Update Amount"
  };

  useEffect(() => {
    if (!formTotal?.amount || Number(formTotal?.amount) === 0) {
        setTdsChecked(false);
        setFormTotal(prev => ({ ...prev, tds_deduction: 0 }));
        setFormTotalName(prev => ({ ...prev, tds_deduction: { label: "", value: "" } }));
    }
}, [formTotal?.amount]);

  return (
    <div>
      <CommonModal {...modifyProps}>
        <div className="addTotalFreight_body">
          <div className="_qntSelector">
            <CustomSelect
              label="Freight Type"
              options={freightTypeList?.length ? freightTypeList : []}
              onSelect={(data) => handleOnChange("freight_type", data?.value)}
              value={freightTypeList?.find(
                (i) => i?.value === formTotal?.freight_type
              )}
              focus={!!formError?.freight_type}
              error={formError.freight_type}
            />
          </div>

          {formTotal?.freight_type !== 6 ? (
            <div className="_clmsFlex">
              <div className="clmDual_fx">
                <CommonInput
                  type="text"
                  name="qty"
                  value={formTotal.qty}
                  // onChange={({ target: { name, value } }) => {
                  //   if (/^(?!0\d)\d*(\.\d{0,2})?$/.test(value) || value === "") {
                  //     handleOnChange(name, value);
                  //   }
                  // }}
                  onChange={({ target: { name, value } }) => {
                    if (/^0[0-9]/.test(value)) {
                      value = value.replace(/^0+/, ''); // "01" → "1"
                    }

                    // Allow "0." for decimals but not "0x" where x is digit
                    if (value === "0") {
                      handleOnChange(name, value);
                      return;
                    }
                    handleOnChange(name, value)
                  }}
                  maxLength={12}
                  onKeyDown={handleKeyDown}
                  label={
                    freightTypeList.length
                      ? freightTypeList?.find(
                        (i) => i?.value === formTotal?.freight_type
                      )?.label
                      : "Qty"
                  }
                  focus={!!formError?.qty}
                  error={formError.qty}
                />
              </div>
              <div className="clmDual_fx">
                <CommonInput
                  type="text"
                  label="Rate"
                  name="rate"
                  value={formTotal.rate}
                  // onChange={({ target: { name, value } }) => {
                  //   if (/^(?!0\d)\d*(\.\d{0,2})?$/.test(value) || value === "") {
                  //     handleOnChange(name, value);
                  //   }
                  // }}
                  onChange={({ target: { name, value } }) => {
                    if (/^0[0-9]/.test(value)) {
                      value = value.replace(/^0+/, ''); // "01" → "1"
                    }

                    // Allow "0." for decimals but not "0x" where x is digit
                    if (value === "0") {
                      handleOnChange(name, value);
                      return;
                    }
                    handleOnChange(name, value)
                  }}
                  maxLength={12}
                  onKeyDown={handleKeyDown}
                  focus={!!formError?.rate}
                  error={formError.rate}
                />
              </div>
            </div>
          ) : (
            <div className="">
              <CommonInput
                type="text"
                // onChange={({ target: { name, value } }) => {
                //   if (/^(?!0\d)\d*(\.\d{0,2})?$/.test(value) || value === "") {
                //     handleOnChange(name, value);
                //   }
                // }}
                onChange={({ target: { name, value } }) => {
                  if (/^0[0-9]/.test(value)) {
                    value = value.replace(/^0+/, ''); // "01" → "1"
                  }

                  // Allow "0." for decimals but not "0x" where x is digit
                  if (value === "0") {
                    handleOnChange(name, value);
                    return;
                  }
                  handleOnChange(name, value)
                }}
                label={
                  freightTypeList.length
                    ? freightTypeList?.find(
                      (i) => i?.value === formTotal?.freight_type
                    )?.label
                    : "Qty"
                }
                placeholder="Enter Freight"
                value={formTotal?.amount}
                name="amount"
                focus={!!formError?.amount}
                error={formError.amount}
                maxLength={15}
                onKeyDown={handleKeyDown}

              />
            </div>
          )}

          <div className="_amtBaar">
            <p>Amount</p>
            <p>
              ₹{" "}
              {formTotal?.amount != null && !isNaN(formTotal.amount)
                ? Number(formTotal.amount)
                  .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : "0.00"}

            </p>
          </div>
          <div>
            <span className="_tdsLabel">TDS Deduction</span>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault"
                checked={tdsChecked}
                // onChange={(e) => setTdsChecked(e.target.checked)}
                disabled={!formTotal?.amount || Number(formTotal?.amount) === 0}  // ← ADD
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  setTdsChecked(isChecked);

                  // Immediately reset if unchecked
                  if (!isChecked) {
                    setFormTotal(prev => ({
                      ...prev,
                      tds_deduction: 0
                    }));
                    setFormTotalName(prev => ({
                      ...prev,
                      tds_deduction: { label: "", value: "" }
                    }));
                  }
                }}
              />
              <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
                {tdsChecked ? "Yes" : "No"}
              </label>
            </div>
            {tdsChecked && (
              <CustomSelect
                label="TDS Deduction %"
                value={
                  formTotal?.tds_deduction !== 0
                    ? tdsList?.find((i) => i?.value === formTotal?.tds_deduction)
                    : { label: "", value: "" }
                }
                options={tdsList}
                disabled={!tdsChecked}
                onSelect={(data) => {
                  handleOnChange("tds_deduction", data?.value);
                  setFormTotalName({ ...formTotalName, tds_deduction: data });
                }}
                focus={!!formError?.tds_deduction}
                error={formError.tds_deduction}
              />
            )}

            {data && Number(formTotal?.amount) > 0 && (  // ← ADD condition
              <div className="_amtBaar">
                <p>TDS Amount</p>
                <p>
                  ₹{" "}
                  {Number(tdsAmmount || 0).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </div>
            )}
          </div>
        </div>
      </CommonModal>
    </div>
  );
};

export default EditConsignorFreight;